module.exports = __webpack_public_path__ + "media/images/flags/64/Sao-Tome-and-Principe-51e8ebb494fd2d3b34689769e1ff17e9.png";